import React from 'react';
import { Box, Typography, Breadcrumbs, Link } from '@material-ui/core';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

const PageHeader = ({
  title,
  routeSegments = []
}) => {
  const history = useHistory();

  const handleBreadcrumbClick = path => {
    if (path) {
      history.push(path);
    }
  };

  return <Box mb={4}>
      {
      /* Title */
    }
      <Typography variant="h4" fontWeight="bold">
        {title}
      </Typography>

      {
      /* Breadcrumbs */
    }
      <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb" sx={{
      mb: 1
    }}>
        {routeSegments.map((segment, index) => {
        const isLast = index === routeSegments.length - 1;
        return isLast ? <Typography key={segment.name}>
              {segment.name}
            </Typography> : <Link key={segment.name} underline="hover" component="button" onClick={() => handleBreadcrumbClick(segment.path)} style={{
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          color: 'inherit',
          textDecoration: 'none',
          fontFamily: 'inherit',
          fontSize: 'inherit'
        }}>
              {segment.name}
            </Link>;
      })}
      </Breadcrumbs>
    </Box>;
};

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  routeSegments: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    path: PropTypes.string
  }))
};
export default PageHeader;